import { useEffect, useRef } from 'react';

/**
 * Runs `refresh` whenever this window regains focus — the return path useRefreshOnVisible cannot see,
 * since an AcombaGO window opened over the host page leaves the iframe visible.
 */
export const useRefreshOnWindowFocus = (refresh: () => void): void => {
    const refreshRef = useRef(refresh);

    useEffect(() => {
        refreshRef.current = refresh;
    }, [refresh]);

    useEffect(() => {
        const onFocus = () => refreshRef.current();
        window.addEventListener('focus', onFocus);
        return () => window.removeEventListener('focus', onFocus);
    }, []);
};
